import { StorageProvider } from '../storage-provider';

export class LocalStorageProvider implements StorageProvider {

  public get(key: string): any {
    const storedString = localStorage.getItem(key);
    let storedItem: any = null;

    try {
      storedItem = JSON.parse(storedString);
    } catch (error) { }

    return storedItem;
  }

  public set(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/storage-provider/local-storage-provider.ts